import { ReactNode, ComponentType, RefAttributes } from 'react';
import { AgenciesQuery } from '../../graphql/graphql';
import { ResidenceCardProps } from '../Cards/ResidencesCard';

export type AgencyListItem = NonNullable<
  NonNullable<AgenciesQuery['agencies']['nodes']>[number]
>;

export enum BusinessItemsType {
  agencies = 'agencies',
  residences = 'residences'
}

export type Item =
  | (Omit<ResidenceCardProps, 'city'> & {
      id: string;
      name: string;
      city?: { name?: string | null } | null;
    })
  | AgencyListItem;

export type BusinessItemsListContainer = ComponentType<
  {
    $isEmptyView?: boolean;
    children?: ReactNode;
  } & RefAttributes<HTMLDivElement>
>;

export interface BusinessItemsListPageProps {
  setErrorUI: (arg: boolean) => void;
  title: string;
  hasError: boolean;
  items: Item[];
  searchItems?: Item[];
  ListContainer: BusinessItemsListContainer;
  type?: BusinessItemsType;
  children?: ReactNode;
  loading?: boolean;
  isMapView?: boolean;
  mapView?: React.ReactNode;
  onLoadMore?: () => void;
  isStopLoad?: boolean;
  isLoadingMore?: boolean;
  onSearchQuery?: (query: string) => void;
}
